import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { isBuyerOrInternalTech } from '../../utils/AuthUtils';
import OverviewShell from '../overview_shell/OverviewShell';

const style = require('./ApprovalHierarchyOverviewPage.less');

const ApprovalHierarchyOverviewPage: FC<any> = ({
	history,
	userType,
	currentUser,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/approvalHierarchies/overview/${key}`),
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const isInternalTechOrBuyer = isBuyerOrInternalTech(currentUser);

	const tabs = [
		...(isInternalTechOrBuyer
			? [
					{
						key: 'rules/workOrder',
						name: 'Work Order Rules',
					},
					{
						key: 'rules/quote',
						name: 'Quote Rules',
					},
					{
						key: 'rules/invoice',
						name: 'Invoice Rules',
					},
			  ]
			: []),
		...(userType === ROLE_TYPES.SUPPLIER
			? [
					{
						key: 'rules/purchaseRequest',
						name: 'Purchase Request Rules',
					},
			  ]
			: []),
		{
			key: 'templates',
			name: 'Approval Hierarchies',
		},
	];

	return (
		<>
			<Route
				path={`/${userType}/approvalHierarchies/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/approvalHierarchies/overview/rules/workOrders`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Approvals"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="supplierWorkOrdersPage"
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({
	userType: state.session.userType,
	currentUser: state.session.currentUser,
});
const mapDispatchToProps = (dispatch) => ({});
export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ApprovalHierarchyOverviewPage)
);
